export default __webpack_public_path__ + "static/media/OpenJApp_2.cdc0cdb3.png";